import AssetsServe from "./AssetsServe";

import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { estoqueGenericoRoutes } from "./estoqueGenericoRoutes";
import AcessLogin from "../pages/Acess/LoginPage";
import AcessoRastreioHavox from "../pages/Acess/AcessoRastreioHavox";
import AcessoRastreioMeusPedidosHavox from "../pages/Laboratorio/Acompanhamento/AcessoRastreioHavox-MeusPedidos";
import AcessCadastro from "../pages/Acess/Cadastro";
import AcessRecuperarSenha from "../pages/Acess/RecuperarSenha";
import SessaoEncerrada from "../pages/Acess/SessaoEncerrada";
import ApiDocPage from "../pages/Api-Documentation/ApiDocsPage";
import LaboratorioGestaoDeCases from "../pages/Laboratorio/Acompanhamento/acompanhamento";
import LaboratorioDetalhesCase from "../pages/Laboratorio/Acompanhamento/DetalhesCase";
import LaboratorioDetalhesCaseTimeline from "../pages/Laboratorio/Acompanhamento/DetalhesCaseTimeline";
import LaboratorioRegistrarCase from "../pages/Laboratorio/Acompanhamento/RegistrarCase";
// --------
import HomeAcess from "../pages/Acess/Home";
//------

//---- TEMPLATE ADMINISTRATIVO -----

// ---------------------------------
import ChooseAction from "../components/chooseAction";
import SuprimentosEmbarcacoesClientes from "../pages/Templates/Template-Administrativo/Coordenacao/EmbarcacoesClientes/embarcacoesCadastradas";

//import RecursosHumanosDEmpresa from "../pages/Recursos-Humanos/D-Empresa/d-empresa";

import RecursosHumanosEmpresasCadastradas from "../pages/Templates/Template-Administrativo/Recursos-Humanos/Clientes/empresasCadastradas";

import ComercialProdutos from "../pages/Templates/Template-Administrativo/Comercial/Produtos/Produtos";
import CoordenacaoProdutos from "../pages/Templates/Template-Administrativo/Coordenacao/Produtos/Produtos";

import RecursosHumanosColaboradores from "../pages/Templates/Template-Administrativo/Recursos-Humanos/Colaboradores/colaboradores";
import RecursosHumanosRegistrarColaborador from "../pages/Templates/Template-Administrativo/Recursos-Humanos/Colaboradores/registrar-colaborador";
import RecursosHumanosDetalhesColaborador from "../pages/Templates/Template-Administrativo/Recursos-Humanos/Colaboradores/DetalhesColaborador";
import RecursosHumanosAlterarDetalhesColaborador from "../pages/Templates/Template-Administrativo/Recursos-Humanos/Colaboradores/editar-colaborador";
// Diretoria
import DiretoriaEstoqueSuprimentos from "../pages/Templates/Template-Administrativo/Diretoria/Suprimentos/Produtos/Produtos";
import DetalhesProdutoDiretoria from "../pages/Templates/Template-Administrativo/Diretoria/DetalhesProduto";
// Coordenacao
import CoordenacaoColaboradores from "../pages/Templates/Template-Administrativo/Coordenacao/Colaboradores/colaboradores";
import CoordenacaoStandby from "../pages/Templates/Template-Administrativo/Coordenacao/Standby/Standby";
import CoordenacaoBaseDeClientes from "../pages/Templates/Template-Administrativo/Coordenacao/EmpresasCadastradas/empresasCadastradas";
import RecursosHumanosRegistrarEmpresa from "../pages/Templates/Template-Administrativo/Recursos-Humanos/Clientes/RegistrarEmpresaCliente";
import CoordenacaoEmbarcacoesClientes from "../pages/Templates/Template-Administrativo/Coordenacao/EmbarcacoesClientes/embarcacoesCadastradas";
import CoordenacaoRegistrarEmbarcacoesClientes from "../pages/Templates/Template-Administrativo/Coordenacao/EmbarcacoesClientes/RegistrarEmbarcacaoCliente";
// Comercial
import ComercialStandby from "../pages/Templates/Template-Administrativo/Comercial/Standby/Standby-comercial";
import ComercialVendas from "../pages/Templates/Template-Administrativo/Comercial/Saidas/Vendas";
import DetalhesProdutoComercial from "../pages/Templates/Template-Administrativo/Comercial/Produtos/DetalhesProduto";
// Suporte
import ProtectedRoute from "./ProtectedRoute";
import PageTransition from "../pages/Acess/PageTransition";
import { governancaCertidoesRoutes } from "./governancaCertidoesRoutes";
import { comprasRoutes } from "./comprasRoutes";
import { financeiroRoutes } from "./FinanceiroRoutes";
// -------
const LoginByDomain: React.FC = () => {
  const hostname = window.location.hostname.toLowerCase().replace(/^www\./, "");

  if (hostname === "logvi-havox.com" || hostname.endsWith(".logvi-havox.com")) {
    return <AcessLogin />;
  }

  return <AcessLogin />;
};

const PdfRedirect: React.FC<{ file: string }> = ({ file }) => {
  useEffect(() => {
    window.location.replace(`/pdf/${file}`);
  }, [file]);
  return null;
};

function withCodigoGuard<C extends React.ComponentType<any>>(Component: C) {
  type Props = React.ComponentProps<C>;
  const Wrapped: React.FC<Props> = (props) => {
    const { codigo } = useParams<{ codigo: string }>();
    if (!codigo) {
      return <Navigate to="/entrar" replace />;
    }
    const onlyLetters = /^[A-Za-z]+$/.test(codigo);
    let isValid = false;
    if (onlyLetters) {
      isValid = true;
    } else {
      if (!/^[A-Za-z0-9]+$/.test(codigo)) {
        isValid = false;
      } else {
        const digits = (codigo.match(/\d/g) || []).length;
        isValid = digits <= 14;
      }
    }
    if (!isValid) {
      return <Navigate to="/entrar" replace />;
    }
    return <Component {...props} />;
  };
  Wrapped.displayName = `withCodigoGuard(${
    Component.displayName || Component.name || "Component"
  })`;

  return Wrapped;
}

const DiretoriaDetalhesGuard = withCodigoGuard(DetalhesProdutoDiretoria);
const ComercialDetalhesGuard = withCodigoGuard(DetalhesProdutoComercial);

const AppRoutes: React.FC = () => {
  const location = useLocation();
  return (
    <Routes location={location} key={location.pathname}>
      {/* Rotas públicas */}
      <Route path="/entrar" element={<LoginByDomain />} />
      <Route path="/assets/*" element={<AssetsServe />} />
      <Route
        path="/politicas/codigo-de-etica-e-conduta"
        element={<PdfRedirect file="HAVOX-CODIGO-DE-ETICA-E-CONDUTA.pdf" />}
      />
      <Route
        path="/politicas/politica-anticorrupcao-e-antissuborno"
        element={
          <PdfRedirect file="HAVOX-POLITICA-ANTICORRUPCAO-E-ANTISSUBORNO.pdf" />
        }
      />
      <Route path="/rastreamento/entrar" element={<AcessoRastreioHavox />} />
      <Route
        path="/Status-do-Servico/laboratorio"
        element={<AcessoRastreioMeusPedidosHavox />}
      />
      <Route
        path="/minhas-solicitacoes/laboratorio-cases"
        element={<AcessoRastreioMeusPedidosHavox />}
      />
      <Route path="/sessao-encerrada" element={<SessaoEncerrada />} />
      <Route path="/cadastro" element={<AcessCadastro />} />
      <Route path="/redefinir-senha" element={<AcessRecuperarSenha />} />
      {/* Documentação & mapa (ainda protegidos) */}
      <Route element={<ProtectedRoute />}>
        <Route
          path="/acess/home"
          element={
            <PageTransition key={location.pathname}>
              <HomeAcess />
            </PageTransition>
          }
        />
        <Route path="/apidoc" element={<ApiDocPage />} />
        {/* ===== rotas com :codigo (com validação) ===== */}

        <Route
          path="/diretoria/produtos/:codigo"
          element={<DiretoriaDetalhesGuard />}
        />
        <Route
          path="/comercial/produtos/:codigo"
          element={<ComercialDetalhesGuard />}
        />
        {/* ============================================= */}
        <Route path="/suprimentos/" element={<ChooseAction />} />
        <Route path="/comercial/" element={<ChooseAction />} />
        <Route path="/recursos-humanos/" element={<ChooseAction />} />
        <Route path="/coordenacao/" element={<ChooseAction />} />
        <Route path="/departamento-pessoal/" element={<ChooseAction />} />
        <Route path="/departamento-tecnico/" element={<ChooseAction />} />
        <Route path="/status-do-servico/" element={<ChooseAction />} />
        <Route path="/laboratorio/" element={<ChooseAction />} />
        <Route path="/financeiro/" element={<ChooseAction />} />
        <Route path="/contabil/" element={<ChooseAction />} />
        <Route
          path="/governanca-qualidade-e-compliance/"
          element={<ChooseAction />}
        />
        <Route
          path="/suprimentos/estoque-p-tecnicos-e-laboratorio/"
          element={<ChooseAction />}
        />
        <Route path="/diretoria/" element={<ChooseAction />} />
        <Route
          path="/laboratorio/gestao-de-cases"
          element={<LaboratorioGestaoDeCases />}
        />
        <Route
          path="/laboratorio/gestao-de-cases/detalhes-case/:codigo"
          element={<LaboratorioDetalhesCase />}
        />
        <Route
          path="/minhas-solicitacoes/laboratorio-cases/timeline/:codigo"
          element={<LaboratorioDetalhesCaseTimeline />}
        />
        <Route
          path="/laboratorio/gestao-de-cases/registrar-case"
          element={<LaboratorioRegistrarCase />}
        />
        {/* Template Administrativo */}
        {comprasRoutes}
        {financeiroRoutes}
        {governancaCertidoesRoutes}
        {estoqueGenericoRoutes}
        {/*  */}
        <Route
          path="/suprimentos/embarcacoes"
          element={
            <SuprimentosEmbarcacoesClientes title="Suprimentos - Embarcações Cadastradas" />
          }
        />
        {/*  */}
        <Route
          path="/recursos-humanos/empresas-cadastradas"
          element={<RecursosHumanosEmpresasCadastradas />}
        />
        <Route
          path="/recursos-humanos/colaboradores"
          element={<RecursosHumanosColaboradores />}
        />
        <Route
          path="/coordenacao/colaboradores"
          element={<CoordenacaoColaboradores />}
        />
        <Route
          path="/recursos-humanos/colaboradores/registrar-colaborador"
          element={<RecursosHumanosRegistrarColaborador />}
        />
        <Route
          path="/recursos-humanos/colaborador/:id"
          element={<RecursosHumanosDetalhesColaborador />}
        />
        <Route
          path="/recursos-humanos/colaborador/:id/editar-colaborador"
          element={<RecursosHumanosAlterarDetalhesColaborador />}
        />
        {/* Diretoria */}
        <Route
          path="/diretoria/estoque-suprimentos"
          element={<DiretoriaEstoqueSuprimentos />}
        />
        {/* Coordenação */}
        {/* <Route
          path="/coordenacao/coordenacao-rastreio-de-materiais"
          element={<CoordenacaoStandby />}
        />*/}
        {/*  <Route
          path="/coordenacao/coordenacao-rastreio-de-materiais/standby"
          element={<CoordenacaoStandby />}
        /> */}
        <Route
          path="/coordenacao/empresas-cadastradas"
          element={<CoordenacaoBaseDeClientes />}
        />
        <Route
          path="/coordenacao/embarcacoes"
          element={
            <CoordenacaoEmbarcacoesClientes title="Coordenação - Embarcações Cadastradas" />
          }
        />
        <Route
          path="/coordenacao/embarcacoes/registrar-embarcacao"
          element={<CoordenacaoRegistrarEmbarcacoesClientes />}
        />
        <Route
          path="/recursos-humanos/empresas-cadastradas/registrar-empresa"
          element={<RecursosHumanosRegistrarEmpresa />}
        />
        {/* Comercial */}
        <Route
          path="/comercial/materiais-p-venda/standby"
          element={<ComercialStandby />}
        />
        <Route
          path="/comercial/materiais-p-venda/produtos"
          element={<ComercialProdutos />}
        />
        <Route
          path="/coordenacao/coordenacao-rastreio-de-materiais/produtos"
          element={<CoordenacaoProdutos />}
        />
        <Route
          path="/comercial/materiais-p-venda/saidas"
          element={<ComercialVendas />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/entrar" replace />} />
    </Routes>
  );
};

export default AppRoutes;
